import { computed } from 'vue'

import { EventDetailId } from '@collector/sportsapi-client-legacy'
import { queryClient } from '@desktop/queryClient'

import {
  CompetitionData,
  updateCompetitionEvent,
} from './queries/useCompetitionQuery'
import { useCompetition } from './useCompetition'
import { useEventId } from './useEventId'

export const useEventDetails = () => {
  const eventId = useEventId()
  const { competition } = useCompetition()

  const eventDetailsMap = computed(() =>
    Object.fromEntries(
      competition.value.season.stage.group.event.details.map((detail) => [
        detail.id,
        detail,
      ]),
    ),
  )

  const getEventDetail = (detailId: EventDetailId) => {
    const eventDetail = eventDetailsMap.value[detailId]
    if (!eventDetail) {
      throw Error(`eventDetail ${detailId} not found`)
    }

    return eventDetail
  }

  const getEventDetailValue = (detailId: EventDetailId) =>
    getEventDetail(detailId).value

  const setEventDetailValue = (
    detailId: EventDetailId,
    value: number | string | null,
  ) => {
    getEventDetail(detailId)
    queryClient.setQueryData<CompetitionData>(
      ['event', 'competition', eventId.value],
      (oldData) =>
        updateCompetitionEvent(oldData, (event) => ({
          ...event,
          details: event.details.map((detail) =>
            detail.id === detailId ? { ...detail, value } : detail,
          ),
        })),
    )
  }

  return { getEventDetail, getEventDetailValue, setEventDetailValue }
}
